import { render, staticRenderFns } from "./mj-stats.vue?vue&type=template&id=408ff91c&lang=pug&"
import script from "./mj-stats.vue?vue&type=script&lang=js&"
export * from "./mj-stats.vue?vue&type=script&lang=js&"
import style0 from "./mj-stats.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports